import { Box, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import Insight from "./Insight.js";
import { suggestions } from "./insightsLabels.js";

// const INSIGHTS_LABELS = {
//   0: "No Action Needed / Due to closed Fresh Air Systems",
//   1: "No Action Needed",
//   2: "Decrease Fresh air for Unoccupied spaces/ Due to zero occupancy.",
//   3: "Increase Fresh air for Occupied areas/ Due to High Co2 Levels.",
//   4: "Decrease Aircondition in Unoccupied areas/ Due to zero occupancy.",
//   5: "Close Aircondition in Unoccupied areas/ Due to zero occupancy.",
//   6: "Decrease Aircondition in Occupied areas/ Due to low temp.",
//   7: "Increase Aircondition in Occupied areas / Due to high temp.",
//   8: "Decrease Heat in Unoccupied areas/ Due to zero occupancy.",
//   9: "Decrease Heat in Unoccupied areas/ Due to zero occupancy.",
//   10: "Increase Heat in Occupied areas/Due to low temp.",
//   11: "Decrease Heat in Occupied areas / Due to high temp.",
//   12: "Close Fresh air for Unoccupied spaces/ Due to zero occupancy.",
//   13: "Decrease Fresh air / Due to Low Co2 Levels.",
// };

const INCREASE_COLOR = "#0af0ed";
const DECREASE_COLOR = "#e74221";

const InsightsContainer = (props) => {
  const dispatch = useDispatch();

  const data = useSelector(
    (state) => state.heatmapData.data.sensorsTypeMeasurements,
  );
  // console.log('data:', data);

  function transformData(sensorsArray) {
    if (sensorsArray.length === 0) {
      return [];
    }
    const insightMap = new Map();

    // Iterate through the array of sensor objects
    sensorsArray.forEach((sensor) => {
      const {
        sensor_id,
        name : sensor_name,
        building_name : building,
        floor: floor_number,
        area_name,
        data,
      } = sensor;

      // Iterate through the data array in each sensor object
      data.forEach(({ insightId, unix_time }) => {
        // insightId === 9999 > is a missing data number.
        if (
          insightId === 1 ||
          insightId === 0.1 ||
          insightId === null ||
          insightId === 9999
        ) {
          // If the insightId is 1 or 0.1, skip this iteration
          return;
        }

        if (!insightMap.has(insightId)) {
          // Initialize a new object for unique insightId
          insightMap.set(insightId, { insightId, sensors: [] });
        }

        // Add the sensor info and unix_time to the insightId entry
        const insightEntry = insightMap.get(insightId);
        const existingSensor = insightEntry.sensors.find(
          (s) => s.sensor_id === sensor_id,
        );

        if (existingSensor) {
          // If the sensor already exists, just add the unix_time
          existingSensor.unix_time.push(unix_time);
        } else {
          // If the sensor doesn't exist, create a new sensor object
          insightEntry.sensors.push({
            sensor_id,
            sensor_name,
            building,
            floor_number,
            area_name,
            unix_time: [unix_time],
          });
        }
      });
    });

    // Convert the Map into an array of objects
    return Array.from(insightMap.values());
  }
  // console.log('data by insights: ', transformData(data));
  const insightsByType = transformData(data);
  // console.log("Array.from(insightMap.values()):",insightsByType);

  return (
    <Box>
      {/* <MDTypography>Insights for the selected Time range:</MDTypography> */}
      {insightsByType.length > 0 ? (
        insightsByType.map((insight) => {
          return (
            <Insight
              insightLabel={suggestions[insight.insightId]}
              data={insight.sensors}
              rangeObj={props.rangeObj}
              key={insight.insightId}
              iconColor={
                suggestions[insight.insightId]?.startsWith("I")
                  ? INCREASE_COLOR
                  : DECREASE_COLOR
              }
            ></Insight>
          );
        })
      ) : (
        <Typography sx={{ marginRight: "1rem" }}>
          No insights for the selected sensors and time range
        </Typography>
      )}
    </Box>
  );
};

export default InsightsContainer;
